export function NoEmbeddingsPanel() {
    return (
        <div className="flex w-full justify-center p-2 text-gray-500">
            No similar content available for this document.
        </div>
    )
}